import { render, staticRenderFns } from "./academic_examination_ftpaper.vue?vue&type=template&id=14439d0f&scoped=true&"
import script from "./academic_examination_ftpaper.vue?vue&type=script&lang=js&"
export * from "./academic_examination_ftpaper.vue?vue&type=script&lang=js&"
import style0 from "./academic_examination_ftpaper.vue?vue&type=style&index=0&id=14439d0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14439d0f",
  null
  
)

export default component.exports